import {AxiosServer, ArrRemoveSubItem, AxiosEsb} from '../../utils';
import {server} from '../../config/serverConfig';
import {message} from 'antd';
import {SET} from "./apiAction";

let namespace = 'clientlist_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const clientlistAc ={






	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},

	GET: (value) => (dispatch, getState) => {
		let store = getState().clientRd;
		let { dataFetchProps, pagination } = store;
		let { current: currentPage, pageSize } = pagination;

		// 在这里设置默认的 guarantee_type 为 0
		dataFetchProps = {
			...dataFetchProps,
			...value,
			guarantee_type: value.guarantee_type || '0', // 如果 value.guarantee_type 不存在，就使用默认值 '0'
			currentPage,
			pageSize,
		};

		let Axios = AxiosServer();

		return Axios.post('/client/findAll', dataFetchProps).then((res) => {
			if (res.data.status === true) {
				pagination = { ...pagination, total: res.data.count };
				dispatch({
					type: namespace + 'forcedUpdate',
					payload: { data: res.data.data, pagination: pagination, dataLoading: false },
				});
				return '刷新成功';
			} else {
				dispatch({ type: namespace + 'forcedUpdate', payload: { dataLoading: false } });
				return '刷新失败';
			}
		}).catch((err) => {
			message.error('userlist ' + err, 10);
			dispatch({ type: namespace + 'forcedUpdate', payload: { dataLoading: false } });
			return '错误';
		});
	},

	SELECTLIMITINFO:(value)=>(dispatch,getState)=>{
		// let store =getState().clientRd;
		// let {shouxindata} =store;
		let Axios = AxiosEsb();
		return Axios.post('/api/towxsbank/queryLimitInfo',value).then((res)=>{
			console.log(res)

			if (res.data.status){
				console.log(res.data.creditLimit)
				dispatch({type: namespace+'forcedUpdate', payload: {limitInfoData:res.data}});
			}else {
				return '查询失败';
			}
		}).catch(err=>{
				console.log(err)
		})

		},

	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let currentState =getState();
		value.id = parseInt(value.id);
		let Axios = AxiosServer();
		return  Axios.post('/client/updateGroups',value).then((res)=>{
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	GETXLS:()=>(dispatch,getState)=>{
		let store =getState().clientRd;
		let {dataFetchProps,searchProps} =store;
		let props ={...dataFetchProps,...searchProps,pageSize: 5000};
		let Axios = AxiosServer();
		return Axios.post('/api/excel/export/client',props).then((res)=>{
			if (res.data.filename){
				return (server.path+ res.data.filename);
			}else{
				return '下载失败';
			}

		}).catch((err)=>{
			message.error('错误:' + err.message,10);
			return '错误'
		})
	},



}



export {clientlistAc};
